import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/sign-up/applicant/verify`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signUpApplicantVerify = {
  post: apiPathFunc(pathBase),
};
